/**
 * Data Configuration
 *
 * Centralized configuration for data fetching behavior and API endpoints
 */

import { getApiUrl, currentEnvironment } from '@/lib/config/environment';

export interface DataConfig {
  apiBaseUrl: string;
  isDevelopment: boolean;
}

/**
 * Get data configuration based on environment variables
 */
export function getDataConfig(): DataConfig {
  const isDevelopment = currentEnvironment === 'development';

  // Get API base URL or fallback
  const apiBaseUrl = getApiUrl() || 'https://api.vale.rip';

  return {
    apiBaseUrl,
    isDevelopment
  };
}

/**
 * Check if we're in local dev mode with real backend
 * This is used to determine if we should skip sending Authorization headers
 * to let the backend auto-inject DEV_USER_JWT_TOKEN
 */
export function isLocalDevWithRealBackend(): boolean {
  const config = getDataConfig();
  return config.isDevelopment && config.apiBaseUrl.includes('100.83.138.91');
}
